import type {
  ExperimentFlowStepDefinition,
  ExperimentFlowStepKey,
} from "../types/experimentFlow.types";

export const EXPERIMENT_FLOW_STEPS: ExperimentFlowStepDefinition[] = [
  { key: "context", label: "Context", index: 1 },
  { key: "research", label: "Research", index: 2 },
  { key: "prototype", label: "Prototype", index: 3 },
  { key: "tags", label: "Tags", index: 4 },
  { key: "finalize", label: "Finalize", index: 5 },
];

export const EXPERIMENT_ROUTES = {
  LEGACY_SETUP: "/innovation/experiment-setup",
  NEW_BASE: "/innovation/experiments/new",
  EXISTING_BASE: "/innovation/experiments/:experimentId",
  NEW_CONTEXT: "/innovation/experiments/new/context",
  NEW_RESEARCH: "/innovation/experiments/new/research",
  NEW_PROTOTYPE: "/innovation/experiments/new/prototype",
  NEW_TAGS: "/innovation/experiments/new/tags",
  NEW_FINALIZE: "/innovation/experiments/new/finalize",
  CONTEXT: "/innovation/experiments/:experimentId/context",
  RESEARCH: "/innovation/experiments/:experimentId/research",
  PROTOTYPE: "/innovation/experiments/:experimentId/prototype",
  TAGS: "/innovation/experiments/:experimentId/tags",
  FINALIZE: "/innovation/experiments/:experimentId/finalize",
} as const;

export const getExperimentStepPath = (
  stepKey: ExperimentFlowStepKey,
  experimentId?: string,
) => {
  if (!experimentId) {
    return `${EXPERIMENT_ROUTES.NEW_BASE}/${stepKey}`;
  }

  return `/innovation/experiments/${encodeURIComponent(experimentId)}/${stepKey}`;
};

export const getExperimentStepKeyByIndex = (
  stepIndex: number,
): ExperimentFlowStepKey | undefined => {
  return EXPERIMENT_FLOW_STEPS.find((step) => step.index === stepIndex)?.key;
};

export const getExperimentStepByPathname = (
  pathname: string,
): ExperimentFlowStepKey => {
  const matchedStep = EXPERIMENT_FLOW_STEPS.find((step) =>
    pathname.endsWith(`/${step.key}`),
  );

  return matchedStep?.key ?? "context";
};
